import { render, staticRenderFns } from "./salesperson-create.vue?vue&type=template&id=732db538&scoped=true&"
import script from "./salesperson-create.vue?vue&type=script&lang=js&"
export * from "./salesperson-create.vue?vue&type=script&lang=js&"
import style0 from "./salesperson-create.vue?vue&type=style&index=0&id=732db538&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "732db538",
  null
  
)

export default component.exports